import axios from 'axios';
import TomSelect from 'tom-select';
import bookingInitDataStorage from '../../../init/data-storage';
import bookingDataStorage from '../../../data-storage';

declare let booking_object: any;

export default class getRooms{ 

    private modDataStorage = new bookingInitDataStorage();

    private modBookingDataStorage = new bookingDataStorage();

    /**
     * Get rooms
     * @returns 
     */
    get(el_rooms: string){
        
        const _that = this;
        
        const settings: any = {
            plugins: ['dropdown_input'],
            valueField: 'id',
            labelField: 'name',
            searchField: 'name',
            preload: true,
            load: function (query, callback) {

                const self = this;
    
                const q = {
                    'name' : query
                }
    
                // Call ajax
                axios.post(booking_object.rest_urls.get_rooms, '')
                .then(function (response: any) {
    
                    callback(response.data);

                    _that.setRoomValue(self);
    
                })
                .catch(function (error: any){
    
                    console.log(error);
    
                });

            },

            render: {
                option: function (item, escape) {
                    return '<span class="block w-full fluid-text-xs">'+ escape(item.name) +'</span>';
                },
                item: function (item, escape) {
                    return '<span>'+ escape(item.name) +'</span>';
                },
            }
        };

        const control: TomSelect = new TomSelect(el_rooms, settings);

        return control;
    
    }

    /**
     * Set room
     * @param control 
     */
    protected setRoomValue(control: any) {
        
        const storeInitData = this.modDataStorage.getLocalStorage();

        if(storeInitData !== null){
            
            // Set value
            const get_room_id = storeInitData?.room_id as unknown as string;

            control.setValue(get_room_id);

        }else{
            
            // Retrieve stored booking data
            const storedValues = this.modBookingDataStorage.getLocalStorage();

            // Set value
            const get_room_id = storedValues?.room_id as unknown as string;

            control.setValue(get_room_id);

        }

    }

}